import { render, staticRenderFns } from "./unManageRank.vue?vue&type=template&id=501fe54d&"
import script from "./unManageRank.vue?vue&type=script&lang=ts&"
export * from "./unManageRank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports